<template lang="pug">
  div.checkbox.clip-check.check-primary.CheckBox
    input(
      :id="uniqueId"
      type="checkbox"
      :checked="value",
      @input="$emit('input', $event.target.checked)"
    )
    label(:for="uniqueId" :class="labelClasses") {{ label }}
</template>

<script>
    let uniqueId = 1;

    export default {
        name: 'CheckBox',

        props: {
            value: {
                type: Boolean,
                required: true
            },
            label: {
                type: String,
                default: ''
            }
        },

        computed: {
            labelClasses() {
                return {
                    'CheckBox-Label_empty': !this.label
                };
            }
        },

        data() {
            return {
                uniqueId: `checkbox-${uniqueId++}`,
                console: console
            };
        }
    };
</script>

<style scoped lang="stylus">
  $block = '.CheckBox'

  {$block}
    margin: auto

  {$block}-Label_empty,
  {$block}-Label_empty:before
    margin-right: -10px
    padding-right: 0
</style>



// WEBPACK FOOTER //
// src/lib/fields/CheckBox.vue